import React from 'react';
import { Award, ChevronRight, X } from 'lucide-react';

const About = ({ showFullAbout, setShowFullAbout }) => {
  const summaryPoints = [
    "Denver native with a rich ballet background",
    "LMU graduate who made LA her home",
    "Former bikini bodybuilding competitor",
    "Founder of The PHYT Gym",
    "Pre and Post Natal Certified Trainer",
    "NASM Certified Personal Trainer"
  ];

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      setShowFullAbout(false);
    }
  };

  return (
    <>
      <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:scale-[1.02] relative group p-6 md:p-8 mt-6 w-full">
        <h3 className="text-lg font-semibold text-purple-900 mb-4">About Coach HT</h3>
        <div className="prose prose-purple max-w-none">
          <p className="text-gray-700 mb-6">
            My name is Heather, you can call me HT for short, HT Physique for long! I'm a Denver native who grew up in a dancing family, trained in the Cecchetti method of ballet. After graduating from LMU in 2012, I made Los Angeles my home and began my journey in fitness.
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            {summaryPoints.map((point, index) => (
              <div key={index} className="flex items-center space-x-3">
                <div className="w-8 h-8 rounded-full bg-purple-50 flex items-center justify-center text-purple-600">
                  <Award className="w-5 h-5" />
                </div>
                <span className="text-gray-700">{point}</span>
              </div>
            ))}
          </div>

          <button
            onClick={() => setShowFullAbout(true)}
            className="mt-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-800 text-white font-bold rounded-xl inline-flex items-center justify-center hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] group-hover:from-purple-700 group-hover:to-purple-900"
          >
            Read Full Story
            <ChevronRight className="w-4 h-4 ml-2" />
          </button>
        </div>
      </div>

      {/* Enhanced Modal Overlay */}
      {showFullAbout && (
        <div className="modal-overlay">
          <div 
            className="modal-backdrop"
            onClick={handleBackdropClick}
          >
            <div className="modal-container">
              <div className="modal-content">
                {/* Header */}
                <div className="modal-header">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center">
                      <Award className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-purple-900">About Coach HT</h3>
                  </div>
                  <button
                    onClick={() => setShowFullAbout(false)}
                    className="modal-close-button"
                    aria-label="Close modal"
                  >
                    <X className="w-6 h-6" />
                  </button>
                </div>

                {/* Content */}
                <div className="modal-body">
                  <div className="prose prose-purple max-w-none">
                    <p className="text-gray-700 mb-6 leading-relaxed">
                      My name is Heather, you can call me HT for short, HT Physique for long! Originally a Denver native, I grew up in a dancing family. My mother owned her own ballet studio, and so did my grandmother. I was trained in the Cecchetti method of teaching ballet, which has been developing since 1918, and which focuses on proper form and alignment. It was my ballet training that made me fall in love with movement.
                    </p>
                    
                    <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-6 mb-6 border-l-4 border-purple-400">
                      <p className="text-gray-700 mb-0 italic">
                        "After graduating from Loyola Marymount University (LMU) in 2012, I decided to make Los Angeles my permanent home. In 2019 I competed in Summer Shredding, a bikini bodybuilding competition."
                      </p>
                    </div>

                    <p className="text-gray-700 mb-6 leading-relaxed">
                      In the three months leading up to the competition, I worked out six days a week, tracking every single calorie in and out. Sounds horrible, I know, but in three months I was able to drop over ten percent in body fat, which translated to a loss of about 20 pounds. That was mind blowing to me because it proved that if I just "trust the process," the process works.
                    </p>

                    <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-6 mb-6 border-l-4 border-green-400">
                      <h4 className="text-lg font-semibold text-gray-800 mb-3">The PHYT Gym Journey</h4>
                      <p className="text-gray-700 mb-0">
                        Soon after the bodybuilding competition, I made a full-time commitment to changing people's lives through health and fitness. I "fired my boss" as they say, and became a full time Fitness Professional. Three months later the pandemic hit, and everything changed. I embarked on my "pandemic project," The PHYT Gym. I converted my old, scary looking garage into a cute, hip, workout space for women.
                      </p>
                    </div>

                    <p className="text-gray-700 mb-6 leading-relaxed">
                      When things opened back up, I found myself energized and ready to help others become the best version of themselves. However, I found that with all my experience, and my certifications, I was still missing something. I still was unable to fully help my female clientele, particularly those who were present or future mothers. Shortly after this realization I decided to reinvest in myself and obtain my Pre and Post Natal Certification.
                    </p>

                    <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl p-6 border border-purple-200">
                      <h4 className="text-lg font-semibold text-purple-800 mb-3">The PHYT Method Philosophy</h4>
                      <p className="text-gray-700 mb-0 leading-relaxed">
                        I strive to make women feel better and look better from the outside in, as well as the inside out. The PHYT Method is not just about working out efficiently with good form. It is about becoming a better, happier, more confident individual through positive habit formation and lifestyle change discussion and support. It is about making realistic changes that produce real results. My job is to get you where you want to be faster.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Enhanced Styles */}
      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 9999;
          animation: modalFadeIn 0.3s ease-out;
        }

        .modal-backdrop {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 1rem;
          overflow-y: auto;
        }

        .modal-container {
          width: 100%;
          max-width: 4xl;
          max-height: 90vh;
          margin: auto;
          animation: modalSlideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          transform-origin: center;
        }

        .modal-content {
          background: white;
          border-radius: 1.5rem;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          overflow: hidden;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5rem 2rem;
          border-bottom: 1px solid #e5e7eb;
          background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
          flex-shrink: 0;
        }

        .modal-close-button {
          padding: 0.5rem;
          border-radius: 0.75rem;
          background: white;
          color: #7c3aed;
          border: 1px solid #e5e7eb;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .modal-close-button:hover {
          background: #f3e8ff;
          transform: scale(1.05);
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .modal-body {
          padding: 2rem;
          overflow-y: auto;
          flex: 1;
        }

        @keyframes modalFadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: scale(0.9) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .modal-container {
            max-width: 100%;
            margin: 0;
            max-height: 100vh;
          }
          
          .modal-content {
            border-radius: 0;
            max-height: 100vh;
          }
          
          .modal-header {
            padding: 1rem 1.5rem;
          }
          
          .modal-body {
            padding: 1.5rem;
          }
        }

        /* Smooth scrolling */
        .modal-body {
          scrollbar-width: thin;
          scrollbar-color: #d1d5db #f9fafb;
        }

        .modal-body::-webkit-scrollbar {
          width: 6px;
        }

        .modal-body::-webkit-scrollbar-track {
          background: #f9fafb;
          border-radius: 3px;
        }

        .modal-body::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 3px;
        }

        .modal-body::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }
      `}</style>
    </>
  );
};

export default About;